import { Component, Inject, Input, OnInit, Optional } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { SelectedService, selectedServiceToken } from 'go-modules/services/selected/selected.service';
import { RouterService, ROUTE_NAMES } from '@go-modules/services/router/router.service';
import { GoSidepanelService } from '@go-modules/services/go-sidepanel/go-sidepanel.service';
import { ActivityNavigationComponent } from '@go-modules/components/activity-navigation/activity-navigation.component';
import { TaskListNavigatorComponent } from '../activity-task-sessions/task-list-navigator/task-list-navigator.component';
import { InviteUsersDialogComponent } from '../dialogs/invite-users-dialog/invite-users-dialog.component';
import { EnvironmentVarsService } from '@go-modules/services/environment-vars/environment-vars.service';
import { ENVIRONMENTS } from '@go-modules/services/environment-vars/environments';
import { NgxActivityViewComponent } from '@go-modules/components/activity-view/activity-view.component';

@Component({
	selector: 'ngx-overview-navigation',
	standalone: true,
	imports: [
		TranslateModule,
		TaskListNavigatorComponent
	],
	templateUrl: './overview-navigation.component.html',
	styleUrls: ['./overview-navigation.component.scss']
})
export class OverviewNavigationComponent implements OnInit {
	@Input() public showInviteButton = true;
	public currentPageIndex: number = 1;
	public readonly TOTAL_PAGES = 3;
	public environmentVarsService: EnvironmentVarsService;

	constructor (
		@Inject(selectedServiceToken) private readonly selectedService: SelectedService,
		private readonly routerService: RouterService,
		private readonly goSidepanelService: GoSidepanelService,
		private readonly dialog: MatDialog,
		@Optional() private readonly activityViewComponent?: NgxActivityViewComponent
	) {
		this.environmentVarsService = EnvironmentVarsService.getInstance();
	}

	public ngOnInit (): void {
		this.updateCurrentPageIndex();
	}

	public onNavigateBack (): void {
		this.activityViewComponent?.setNextRouteAnnouncementPoliteness('assertive');
		this.activityViewComponent?.setNextRouteFocusSelector('.task-details-navigator-btn.prev-btn');
		const currentIndex = this.getOverviewPageIndex();
		const internalIndex = currentIndex - 1;
		const previousInternalIndex = internalIndex - 1;
		this.navigateToOverviewPage(previousInternalIndex);
	}

	public onNavigateForward (): void {
		this.activityViewComponent?.setNextRouteAnnouncementPoliteness('assertive');
		this.activityViewComponent?.setNextRouteFocusSelector('.task-details-navigator-btn.next-btn');
		const currentIndex = this.getOverviewPageIndex();
		const internalIndex = currentIndex - 1;
		const nextInternalIndex = internalIndex + 1;
		this.navigateToOverviewPage(nextInternalIndex);
	}

	public onOpenNavigator (): void {
		this.goSidepanelService.open(ActivityNavigationComponent, {
			noFooter: true,
			panelClass: ['animated', 'activity-navigation-panel'],
			title: ' ',
			inputs: {}
		});
	}

	private getOverviewPageIndex (): number {
		const currentRoute = this.routerService.getCurrentRouteName();
		const currentParams = this.routerService.getCurrentParams();

		if (currentRoute === ROUTE_NAMES.DASHBOARD_ACTIVITY_TASK && currentParams.type === 'evaluate') {
			return 1;
		} else if (currentRoute === ROUTE_NAMES.DASHBOARD_ACTIVITY_TASK_REPORT) {
			return 2;
		} else if (currentRoute === ROUTE_NAMES.DASHBOARD_ACTIVITY_REPORT) {
			return 3;
		}

		return 1;
	}

	private updateCurrentPageIndex (): void {
		this.currentPageIndex = this.getOverviewPageIndex();
	}

	private navigateToOverviewPage (internalIndex: number): void {
		const activity = this.selectedService.getActivity();
		const currentQueryParams = this.routerService.getCurrentQueryParams();

		switch (internalIndex) {
			case 0:
				this.routerService.navigateTo(ROUTE_NAMES.DASHBOARD_ACTIVITY_TASK, {
					activity_id: activity.activity_id,
					type: 'evaluate'
				}, {
					queryParams: currentQueryParams
				});
				break;
			case 1:
				this.routerService.navigateTo(ROUTE_NAMES.DASHBOARD_ACTIVITY_TASK_REPORT, {
					activity_id: activity.activity_id
				}, {
					queryParams: currentQueryParams
				});
				break;
			case 2:
				this.routerService.navigateTo(ROUTE_NAMES.DASHBOARD_ACTIVITY_REPORT, {
					activity_id: activity.activity_id
				}, {
					queryParams: currentQueryParams
				});
				break;
		}
	}

	public openInviteModal (): void {
		InviteUsersDialogComponent.open(this.dialog, {
			data: { group: this.selectedService.getGroup() }
		});
	}

	public isLti (): boolean {
		return this.environmentVarsService.environmentIs(ENVIRONMENTS.LTI);
	}
}
